export default{
    // confirmation
    "clinic.detail.cart.confirmation.title"               : "Confirmation d'inscription",
    "clinic.detail.cart.confirmation.thankYou"            : "Merci de votre inscription!",
    "clinic.detail.cart.confirmation.receiptNumber"       : "Votre numéro de reçu est",
    "clinic.detail.cart.confirmation.emailSentTo"         : "Un courriel a été envoyé à",
    "clinic.detail.cart.confirmation.attacments.title"    : "Voici les pièces jointes fournies par votre stage.",
    "clinic.detail.cart.confirmation.attacments.subtitle" : "Cliquez pour télécharger",
}